import { render, staticRenderFns } from "./MaxparAssistanceIntegrationContent.vue?vue&type=template&id=a2361712"
import script from "./MaxparAssistanceIntegrationContent.vue?vue&type=script&lang=js"
export * from "./MaxparAssistanceIntegrationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports